import { defineStore } from "pinia";
import { version } from "@/../package.json";
import { BottomTab } from "@/types";

export interface LayoutState {
  version: string;
  isLeftSidebarOpen: boolean;
  isRightSidebarOpen: boolean;
  isBottomDrawerOpen: boolean;
  isPageLoading: boolean;
  isDrawToolOpen: boolean;
  drawerH: number;
  rightSidebarIndex: number;
  leftSidebarIndex: number;
  $page: string;
  config: {
    companyLogo?: string;
    companyName?: string;
  };
  beforeDrawerHideState: {
    isLeftSidebarOpen: boolean;
    isRightSidebarOpen: boolean;
  };

  bottomActiveTab?: BottomTab;
}

export const useLayout = defineStore("layout", {
  state: (): LayoutState => ({
    version,
    isLeftSidebarOpen: false,
    isRightSidebarOpen: false,
    isBottomDrawerOpen: false,
    $page: "",
    isPageLoading: true,
    isDrawToolOpen: false,
    drawerH: 0,
    rightSidebarIndex: 0,
    leftSidebarIndex: 0,
    config: {},
    beforeDrawerHideState: {
      isLeftSidebarOpen: false,
      isRightSidebarOpen: false,
    },
    bottomActiveTab: undefined,
  }),
  getters: {
    drawerHeight(): number {
      return this.isBottomDrawerOpen ? this.drawerH : 0;
    },
    page(): string {
      return this.$page || "map";
    },
    isMapPage(): boolean {
      return this.page === "map";
    },
  },
  actions: {
    set(config: Partial<LayoutState>) {
      Object.assign(this, config);
    },
    hideDrawers() {
      this.beforeDrawerHideState = {
        isLeftSidebarOpen: this.isLeftSidebarOpen,
        isRightSidebarOpen: this.isRightSidebarOpen,
      };
      this.isLeftSidebarOpen = false;
      this.isRightSidebarOpen = false;
    },
    restoreDrawers() {
      this.isLeftSidebarOpen = this.beforeDrawerHideState.isLeftSidebarOpen;
      this.isRightSidebarOpen = this.beforeDrawerHideState.isRightSidebarOpen;
    },
    setBottomActiveTab(tab: BottomTab, openDrawer?: boolean) {
      this.bottomActiveTab = tab;

      if (typeof openDrawer !== "undefined")
        this.isBottomDrawerOpen = openDrawer;
    },

    setRightSidebarStatus(isOpen: boolean) {
      this.isRightSidebarOpen = isOpen;
    },
  },
});
